import * as React from "react";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const defaultProps = {};
const badgeClass = css({
    color: getThemeColorVar("white", undefined),
    backgroundColor: getThemeColorVar("black", undefined),
    display: "inline-block",
    height: "20px",
    lineHeight: "20px",
    borderRadius: "10px",
    padding: "0 10px",
    border: "none",
    cursor: "default",
    boxSizing: "border-box",
    textAlign: "center",
    verticalAlign: "baseline",
    whiteSpace: "nowrap",
    userSelect: "none",
    fontSize: "13px",
    fontFamily: "inherit",
    fontWeight: "bold",
});
const badgeLargeClass = css({
    height: "24px",
    lineHeight: "24px",
    borderRadius: "12px",
    padding: "0 12px",
    fontSize: "16px",
    verticalAlign: "baseline",
    fontWeight: "normal",
});
export const Badge = (props) => {
    const classes = [badgeClass];
    const emotionStyles = [];
    if (props.color) {
        if (props.color == "transparent") {
            emotionStyles.push({ backgroundColor: "rgba(200, 200, 200, .4)" });
        }
        else {
            emotionStyles.push({
                backgroundColor: `var(--revo-color-${props.color}-${props.colorModifier || "default"})`,
            });
        }
    }
    classes.push(css(emotionStyles));
    if (props.size && props.size === "large") {
        classes.push(badgeLargeClass);
    }
    return React.createElement("span", { className: cx(classes) }, props.children);
};
Badge.defaultProps = defaultProps;
export default Badge;
//# sourceMappingURL=badge.js.map